export const ADMIN_EMAILS = ["tim@opinno.co.kr"];
export const isAdmin = (email) => ADMIN_EMAILS.includes(email);
